export default __webpack_public_path__ + "static/placeholder-d97bb8da315dbae38d651d1ff982fa1b.png";